import '../../styles/skeleton.scss'

const CategorySkeleton = () => {
    return (
        <div className='categoryOpts skeleton'>


            <div className='eachCategory skeleton'>
                <div className='c_pack'>
                    <div className={`checkbox one`} >          
                    </div>

                    
                </div>

            </div>


             <div className='eachCategory skeleton'>
                <div className='c_pack'>
                    <div className={`checkbox two`} >          
                    </div>

                    
                </div>

            </div>


             <div className='eachCategory skeleton'>
                <div className='c_pack'>
                    <div className={`checkbox three`} >          
                    </div>

                    
                </div>

            </div>


             <div className='eachCategory skeleton'>
                <div className='c_pack'>
                    <div className={`checkbox four`} >          
                    </div>

                    
                </div>

            </div>

             <div className='eachCategory skeleton'>
                <div className='c_pack'>
                    <div className={`checkbox five`} >          
                    </div>

                    
                </div>

            </div>


        </div>
    )
}


export default CategorySkeleton;